var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 567,
    viewBox: "0 0 567 567",
    fill: "none",
    id: "svg1009",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      mixBlendMode: "normal"
    },
    id: "path61389",
    cx: 282.5455,
    cy: 283.5767,
    r: 273.5515,
    fill: "none",
    fillOpacity: 1,
    stroke: "#151a20",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      mixBlendMode: "normal"
    },
    id: "path57522",
    cx: 282.5455,
    cy: 283.5767,
    r: 238.2693,
    fill: "none",
    fillOpacity: 1,
    stroke: "#151a20",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      mixBlendMode: "normal"
    },
    id: "path51741",
    cx: 282.3732,
    cy: 282.552,
    r: 204.1415,
    fill: "none",
    fillOpacity: 1,
    stroke: "#151a20",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      mixBlendMode: "normal"
    },
    id: "path46528",
    cx: 282.5455,
    cy: 282.9212,
    r: 175.4422,
    fill: "none",
    fillOpacity: 1,
    stroke: "#151a20",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      mixBlendMode: "normal"
    },
    id: "path39441",
    cx: 279.2597,
    cy: 280.6523,
    r: 144.0428,
    fill: "none",
    fillOpacity: 1,
    stroke: "#151a20",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1,
    paintOrder: "normal"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    id: "circle1438",
    d: "M423.206 285.926a144.0428 144.0428 0 0 1-103.1482 132.8706 144.0428 144.0428 0 0 1-158.7838-55.5144 144.0428 144.0428 0 0 1 2.1113-168.1954 144.0428 144.0428 0 0 1 160.1272-51.5112",
    fill: "none",
    fillOpacity: 1,
    stroke: "#4e9c11",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1,
    paintOrder: "normal"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    id: "circle1436",
    d: "M448.6189 339.4862A175.4422 175.4422 0 0 1 281.273 458.3588a175.4422 175.4422 0 0 1-165.604-121.2874 175.4422 175.4422 0 0 1 62.8365-195.4147 175.4422 175.4422 0 0 1 205.2588-2.0349",
    fill: "none",
    fillOpacity: 1,
    stroke: "#f9d85e",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    id: "circle1434",
    d: "M486.315 291.579a204.1415 204.1415 0 0 1-166.974 191.7393A204.1415 204.1415 0 0 1 95.0226 363.629a204.1415 204.1415 0 0 1 66.2997-245.456",
    fill: "none",
    fillOpacity: 1,
    stroke: "#6493f1",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    id: "circle1413",
    d: "M520.7104 290.628A238.2693 238.2693 0 0 1 301.537 521.0878 238.2693 238.2693 0 0 1 48.5272 328.384",
    fill: "none",
    fillOpacity: 1,
    stroke: "#4e9c11",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "normal"
    },
    id: "path1144",
    d: "M555.7623 297.1046A273.5515 273.5515 0 0 1 414.837 523.0123a273.5515 273.5515 0 0 1-266.2582-.9332",
    fill: "none",
    fillOpacity: 1,
    stroke: "#f72585",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeOpacity: 1
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.3e0e1b2019a2142292b8ff26ece10450.svg";
export { ForwardRef as ReactComponent };